export default "__VITE_ASSET__BFaLIv0r__"